import { Checkbox, Fab, ListItemText, makeStyles, MenuItem, TextField } from '@material-ui/core';
import React, { useMemo, useState, useEffect } from 'react';
import { useForm, Controller } from 'react-hook-form';
import FilterIcon from '@material-ui/icons/FilterList';
import { useRecentGetter } from '@lib/common';
import { $in } from '../operators';
import { startCase } from 'lodash';
import Observable, { Observer } from 'rxjs';
import CircularProgress from '@material-ui/core/CircularProgress';
import InputAdornment from '@material-ui/core/InputAdornment';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { map } from 'rxjs/operators';
import { SiElementary } from 'react-icons/si';
type EnumObject = { label: any; value: any };
type EnumMap = EnumObject[];
const useStyles = makeStyles({
  root: {
    width: '300px',
  },
  center: {
    textAlign: 'center',
  },
});
import styled from 'styled-components';

const AutoCompleteFIlterDiv = styled.div`
  display: flex;
  flex-direction: row;
`;
export function withMultiSelectAutoComplete<T>(
  dataObservable: any,
  requiredMaster: string,
  requiredLabel: string,
  revertLabels: boolean = false,
  appendOthers: boolean = false
) {
  return function filtersMultiSelectAutoComplete(props) {
    const [masterData, setMasterData] = useState([]);
    const [apiLoading, setApiLoading] = useState(true);
    useEffect(() => {
      const subscription = dataObservable()
        .pipe(map(data => data[requiredMaster]))
        .subscribe({
          next: data => {
            const requiredMasterData =
              appendOthers && data ? [...data, { id: 835, service: 'Others' }] : data;
            setMasterData(requiredMasterData);
            setApiLoading(false);
          },
          error: err => {
            setApiLoading(false);
          },
        });
      return () => subscription.unsubscribe();
    }, []);
    const classes = useStyles();
    const { handleSubmit, ...form } = useForm();
    const {
      column: { filterValue, setFilter },
      closeFilter,
    } = props;

    const getFilterValue = useRecentGetter(filterValue);
    const getFilterSetter = useRecentGetter(setFilter);
    const getCloseFilter = useRecentGetter(closeFilter);

    const submit = useMemo(
      () =>
        handleSubmit(values => {
          const toSet = {
            ...getFilterValue(),
          };
          if (values.value) {
            toSet[$in.key] = values.value
              .map(element =>
                revertLabels
                  ? `${element[requiredLabel]}|||${element['service']}`
                  : element[requiredLabel]
              )
              .join(',');
            getFilterSetter()(toSet);
          }
          getCloseFilter()();
        }),
      []
    );

    return (
      <form onSubmit={submit}>
        <AutoCompleteFIlterDiv>
          <Controller
            control={form.control}
             defaultValue={[]}   // <-- required for multiple select
            name="value"
            onChange={([, data]) => {
              return data;
            }}
            render={({ onChange, value }) => {
              return (
                <Autocomplete
                  multiple
                  disableClearable
                  id="values"
                  options={masterData}
                 getOptionLabel={option => option?.service || option?.name||""}
                  onChange={(e, data) => {
                    onChange(data);
                  }}
                  renderInput={params => (
                    <TextField
                      classes={{ root: classes.root }}
                      {...params}
                      variant="standard"
                      label="Multiple values"
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <React.Fragment>
                            {apiLoading ? <CircularProgress color="inherit" size={20} /> : null}
                            {params.InputProps.endAdornment}
                          </React.Fragment>
                        ),
                      }}
                    />
                  )}
                />
              );
            }}
          />
          &nbsp;&nbsp;&nbsp;&nbsp;
          <Fab color="primary" size="small" type="submit">
            <FilterIcon />
          </Fab>
        </AutoCompleteFIlterDiv>
      </form>
    );
  };
}
